/**
 * Supply both clipboard formats for selections fully inside a read-only editor.
 * Listen on the document: a non-editable selection can dispatch copy on body.
 */
export function copyRichTextSelection(event, editor) {
  if (!editor || !event.clipboardData || event.defaultPrevented) return;

  // Input selections can leave an unrelated DOM selection behind.
  const target = event.target;
  if (
    target?.closest?.('input, textarea, [contenteditable="true"]') &&
    !editor.contains(target)
  ) return;

  const selection = editor.ownerDocument.getSelection();
  if (!selection || selection.isCollapsed || selection.rangeCount !== 1) return;

  const range = selection.getRangeAt(0);
  if (
    !editor.contains(range.startContainer) ||
    !editor.contains(range.endContainer)
  ) return;

  const selectedText = selection.toString();
  const rangeText = range.toString();
  const text = selectedText.trim() ? selectedText : rangeText || selectedText;
  if (!text) return; // Let the browser copy image-only selections normally.

  const fragment = editor.ownerDocument.createElement("div");
  fragment.appendChild(range.cloneContents());
  event.clipboardData.setData("text/plain", text);
  event.clipboardData.setData("text/html", fragment.innerHTML);
  event.preventDefault();
}
